import {
  Box,
  chakra,
  Container,
  SimpleGrid,
  Flex,
  Stack,
  HStack,
  Link,
  Text,
  VisuallyHidden,
  Center,
  useColorModeValue,
  Button,
  Image,
  Modal,
  ModalOverlay,
  ModalContent,
  useDisclosure,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Spacer,
  AspectRatio
} from '@chakra-ui/react';
import { ReactNode } from 'react';
import { FaInstagram, FaLinkedinIn, FaYoutube } from 'react-icons/fa';
import React, { } from "react";
import { v4 as uuidv4 } from "uuid";
// import clouds from './assets/clouds.png';
import logo from '../assets/logo.png';
// import Logotextual from './components/logo-textual'

const SocialButton = ({
  children,
  label,
  href,
}: {
  children: ReactNode;
  label: string;
  href: string;
}) => {
  return (
    <chakra.button
      // bg={'#fafafa'}
      bg={useColorModeValue('#fafafa', 'gray.700')}
      rounded={'full'}
      w={12}
      h={12}
      cursor={'pointer'}
      as={'a'}
      href={href}
      display={'inline-flex'}
      alignItems={'center'}
      justifyContent={'center'}
      transition={'background 0.3s ease'}
      _hover={{
        color: 'gray.500',
        transform: "scale(0.98)",
        transition: 'all .1s ease',
        // bg: useColorModeValue('blackAlpha.200', 'whiteAlpha.200'),
      }}
      _active={{
        color: 'gray.500',
        transform: "scale(0.96)",
        transition: 'all .1s ease',
        // bg: useColorModeValue('blackAlpha.200', 'whiteAlpha.200'),
      }}
    >
      <VisuallyHidden>{label}</VisuallyHidden>
      {children}
    </chakra.button>
  );
};

export default function LargeWithNewsletter() {
  return (
    <Center
      w={'full'}
      // opacity={0.75}
      backgroundSize={'cover'}
      backgroundPosition={'bottom'}
      alt='clouds'
      position={'center,center'}
    >
      <Box
        color={useColorModeValue('gray.700', 'gray.200')}>
        <Container
          as={Stack}
          maxW={'full'}
        >
          <SimpleGrid
            templateColumns={{ sm: '1fr 1fr', md: '2fr 1fr 1fr 2fr' }}
            spacing={8}
            pb={8}
            >
            <Stack spacing={6}>
              <Box>
                {/* <AspectRatio> */}
                <Image src={logo} />
                {/* </AspectRatio> */}
              </Box>
            </Stack>
          </SimpleGrid>
          <Footer />
        </Container>

      </Box>

    </Center>
  );
}

const Footer = () => {
  return (
    <Container 
          maxW={'full'}
    >

        <Flex w="full" mb="6" align={{ base: 'center', md: 'right' }} direction={{ base: 'column-reverse', md: 'row' }} textAlign='center'>
          <Text
            mt={{ base: '6', md: '4' }}
            textAlign='center' fontSize="2xs" textTransform="uppercase" fontWeight="300" letterSpacing={0.5}
            color={useColorModeValue('black', 'white')}
          >
            © Sharel Liu 2024. All rights reserved.
          </Text>
          <Spacer />
          <HStack>
            <Stack direction={'row'} 
            spacing={6} 
            align={'flex-start'}>
              <Link href='https://www.youtube.com/@sharelsj' isExternal>
                <SocialButton label={'Youtube'} >
                  <FaYoutube />
                </SocialButton>
              </Link>
              <Link href='https://www.instagram.com/sharel.sj/' isExternal>
                <SocialButton label={'Instagram'} >
                  <FaInstagram />
                </SocialButton>
              </Link>
              <Link href='https://www.linkedin.com/in/sharelsj/' isExternal>
                <SocialButton label={'LinkedIn'} >
                  <FaLinkedinIn />
                </SocialButton>
              </Link>
              <Legalbutton />
            </Stack>


          </HStack>
        </Flex>
      
    </Container>
  );
};

function Legalbutton() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  return (
    <>
      <Button onClick={onOpen}

        color={useColorModeValue('blackAlpha', 'whiteAlpha')}
        key={uuidv4()}
        bg={'transparent'}
        textTransform="uppercase"
        fontSize={{ base: "2xs", lg: "2xs" }}
        fontWeight="400"
        p={{ base: "2", lg: "4" }}
        _hover={{
          color: 'black',
          bg: 'transparent'
        }}
      >
        t&c</Button>

      <Modal isOpen={isOpen} onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent >
          <ModalHeader>
            {/* <Logotextual /> */}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody >
            <Legal />
          </ModalBody>

          <ModalFooter>

          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}


function Legal() {
  return (
    <Text fontSize={{ base: '2xs', lg: 'xs' }}>

      Welcome to the website ("Site") of Sharel Liu. Please read the following terms and conditions before using this Site.

      <br /><br />
      © COPYRIGHT NOTICE 2024 <br/><br/>
      

Drawings, design concepts, and all the contents represented herein are the copyright of Sharel Liu. All rights reserved.
<br/><br/>
No part of the drawing and the design contained herein may be reproduced without the prior written consent of Sharel Liu.
<br /><br />

      DISCLAIMER<br /><br />

      The information and materials contained or referred to on this website are for reference only. Sharel Liu makes no representation or warranty of any kind, express, implied or statutory, regarding this website or the materials and information contained or referred to on each page associated with this website. The information and materials contained on this website are subject to change without notice, are provided for general information only and should not be used as a basis for making construction decisions. Any advice or information received via this website should not be relied upon without consulting primary or more accurate or more up-to-date sources of information or specific professional advice. You are recommended to obtain such professional advice where appropriate.
      <br /><br />

      Sharel Liu accepts no liability and will not be liable for any loss or damage arising directly or indirectly (including special, incidental or consequential loss or damage) from your use of this website, howsoever arising, including any loss, damage or expense arising from, but not limited to, any defect, error, imperfection, fault, omission, mistake or inaccuracy with this website, its contents or associated services, or due to any unavailability of the website or any part thereof or any contents or associated services. Sharel Liu further neither assumes nor accepts liability for any loss or damage arising directly or indirectly (including special, incidental or consequential loss or damage), howsoever caused, as a result of any computer viruses or worms, software bombs or the like arising from your use of this website.
      <br /><br />

      References in this website to any products, events or services do not necessarily constitute or imply Sharel Liu's endorsement or recommendation of them.

      <br /><br />
      Any “off-site” web pages or hypertext link from this website exist for information purposes and are for your convenience only and Sharel Liu accepts no liability for any loss or damage arising directly or indirectly (including special, indirect or consequential loss or damage) from the accuracy or otherwise of materials or information contained on the pages of such sites. Sharel Liu’s inclusion of hyperlinks or “off-site” web pages does not imply any endorsement of the materials on such sites.
    </Text>
  );
}